import React, { useEffect } from 'react';
import {
    Box,
    H2,
} from '@saladbob/sassafras'

import { useRouter } from 'next/router';

import { fetchUser } from '../../hooks/useSwr';
import { useEnv } from '../../components/providers/EnvProvider';

import getSite from '../../crud/getSite';
import CreateAccount from '../../components/CreateAccount';
import Layout from '../../components/Layout';
import type { NextPageWithLayout, PageProps } from '../_app';

type Props = {
    Header: React.FC,
};

export async function getStaticProps() {
    const site = await getSite();

    return {
        props: {
            ...site,
        },
    }
}

const Page: NextPageWithLayout<Props> = () => {
    const { user, mutate } = fetchUser();
    const router = useRouter();
    const env = useEnv();

    const onCreate = async (user) => {
        mutate({ user }, {
            populateCache: true,
            revalidate: false,
        });
    };

    const redirect = () => {
        const routePath = Array.isArray(router.query.redirect)
            ? decodeURI(router.query.redirect[0])
            : router.query.redirect ? decodeURI(router.query.redirect) : '/dashboard';
        router.push(routePath);
    };

    useEffect(() => {
        if (!user?.isLoading && user?.id) {
            redirect();
        }
    }, [user]);

    return (
        <Box bgColor="white">
            <Box minHeight={`calc(100vh - ${env.headerHeight}px)`} verticalAlign="center" padding={['lg', 'md']}>
                <H2 margin={[0, 'auto', 'lg', 'auto']}>Create Your Account</H2>
                <CreateAccount onCreate={onCreate} />
            </Box>
        </Box>
    );
};

Page.getLayout = function getLayout(page: React.ReactElement, pageProps: PageProps ) {
    return (
        <Layout { ...pageProps }>
            {page}
        </Layout>
    )
}

export default Page;